type HotelRoomEventType = {
  title: string;
  hotelName: string;
  checkInDate: string;
  checkOutDate: string;
  childCount?: number;
  adultCount?: number;
  price?: number;
  serviceType: string;
};

export const addHotelRoomSelectionClickEventToGTM = ({
  title,
  hotelName,
  checkInDate,
  checkOutDate,
  childCount,
  adultCount,
  serviceType,
  price,
}: HotelRoomEventType) => {
  dataLayer.push({
    Category: 'Enhanced Ecommerce',
    Action: 'Product Room Selection',
    Label: hotelName + '|' + title,
    cd_selected_room_price: price,
    cd_service_date: checkInDate + '|' + checkOutDate,
    cd_passangers_count: adultCount + '|' + childCount,
    cd_service_type: serviceType,
    noninteraction: false,
    event: 'gaEvent',
  });
};

export const addHotelLetUsCallYouClickEventToGTM = ({
  title,
  hotelName,
  checkInDate,
  checkOutDate,
  childCount,
  adultCount,
  serviceType,
}: HotelRoomEventType) => {
  dataLayer.push({
    Category: 'Enhanced Ecommerce',
    Action: 'Biz Sizi Arayalım',
    Label: hotelName + '|' + title,
    cd_service_date: checkInDate + '|' + checkOutDate,
    cd_passangers_count: adultCount + '|' + childCount,
    cd_service_type: serviceType,
    noninteraction: false,
    event: 'gaEvent',
  });
};

export const addHotelLetUsCallYouSuccessEventToGTM = ({
  title,
  hotelName,
  checkInDate,
  checkOutDate,
}: HotelRoomEventType) => {
  dataLayer.push({
    Category: 'Enhanced Ecommerce',
    Action: 'Biz Sizi Arayalım - Lead Success',
    Label: hotelName + '|' + title,
    cd_service_date: checkInDate + '|' + checkOutDate,
    noninteraction: false,
    event: 'gaEvent',
  });
};
